// extracted by mini-css-extract-plugin
export default {"deliveriesBlock":"Deliveries_deliveriesBlock__i53ib","deliveries":"Deliveries_deliveries__mbFgT"};